import { createSlice } from '@reduxjs/toolkit';

import type { AppState } from './types/AppState';

const initialState: AppState = {
  isUnsupportedBrowserBannerDismissed: false,
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    dismissUnsupportedBrowserBanner: (state) => ({ ...state, isUnsupportedBrowserBannerDismissed: true }),
  },
});

export default appSlice;
